<template>
  <div class="ml-220 mt-80">
    <form @submit.prevent="addNewStory">
      <div class="form-elems">
        <input
          name="story_title"
          :state="validateState('story_title')"
          v-validate="'required'"
          type="text"
          class="title-input"
          placeholder="Заголовок"
          v-model="title">
        <!--<input type="text" class="discription-input" placeholder="Описание" v-model="discription">-->
        <b-form-file
          name="story_file"
          :state="validateState('story_file')"
          v-validate="'required'"
          v-model="imageData"
          @change="previewImage" class="mt-2"
          :file-name-formatter="formatNames"></b-form-file>
        <textarea
          name="story_text"
          :state="validateState('story_text')"
          v-validate="'required'"
          type="text"
          class="text-input"
          placeholder="Текст"
          v-model="text">
        </textarea>
        <button type="submit" class="type-submit">Добавить историю</button>
      </div>
    </form>
    <div class="loader pt-100" v-if="loading">
      <b-spinner label="Spinning" variant="primary"></b-spinner>
    </div>
    <div class="stories" v-else>
      <div class="stories-page pt-3">
        <div
          class="stories-item"
          v-for="(item, id) in getStories"
          :key="id">
          <div @click="delStory(item.id)" class="cross" v-b-tooltip="'Удалить'"><cross/></div>
          <b-row>
            <b-col cols="12">
              <div class="img-wrapper">
                <div class="link-mode">
                  <button class="button" @click="$router.push(`/storyedit/${item.id}`)">Редактировать <under-arrow/></button>
                </div>
                <div class="img-holder image-block">
                  <img :src="item.picture" class="img-fluid img-responsive contain image-content" alt="">
                </div>
              </div>
            </b-col>
          </b-row>
          <p class="stories-item-title">{{item.title}}</p>
          <pre><p class="stories-item-text">{{item.text | truncate(150)}}</p></pre>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapMutations, mapGetters} from 'vuex'
  import UnderArrow from '@/components/icons/UnderArrow';
  import Cross from '@/components/icons/Cross2';
  import firebase from 'firebase';
  import validate from '@/mixins/validate';

  export default {
    components: { Cross, UnderArrow},
    mixins: [validate],
    data() {
      return {
        title: '',
        discription: '',
        text: '',
        loading: true,
        imageData: null,
        picture: null,
        uploadValue: 0
      }
    },
    computed: {
      ...mapGetters('stories', ['getStories'])
    },
    async mounted() {
      this.loading = true
      const response = await this.fetchStories()
      this.setStories(response)
      this.loading = false
    },
    filters: {
      truncate: function (value, limit) {
        if (value.length > limit) {
          value = value.substring(0, (limit - 3)) + '...';
        }
        return value
      },
    },
    methods: {
      ...mapMutations('stories', ['setStories']),
      ...mapActions('stories', ['addArticle', 'fetchStories', 'deleteStory']),
      previewImage(event) {
        this.uploadValue=0;
        this.picture=null;
        this.imageData = event.target.files[0];
      },

      formatNames(files) {
        if (files.length === 1) {
          return files[0].name
        } else {
          return `${files.length} files selected`
        }
      },
      async addNewStory() {
        this.loading = true
        this.$validator.validateAll().then(v => {
          if(!v) return
          try {
            this.picture = null;
            const storageRef = firebase.storage().ref(`${this.imageData.name}`).put(this.imageData);
            storageRef.on(`state_changed`, snapshot => {
                this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              }, error => {
                console.log(error.message)
              },
              () => {
                this.uploadValue = 100;
                this.loading = false
                storageRef.snapshot.ref.getDownloadURL().then(async (url) => {
                  this.picture = url;
                  const formData = {title: this.title, text: this.text, picture: this.picture}
                  try {
                    await this.addArticle(formData)
                    this.resetData()
                  } catch (e) {
                    throw e
                  }
                });
              }
            );
          } catch (e) {
            throw e
          }
        })
        this.loading = false
      },
      async delStory(id) {
        this.loading = true
        await this.deleteStory(id)
        this.loading = false
      },
      resetData() {
        this.title = ''
        this.discription = ''
        this.text = ''
        this.imageData = null
        this.$validator.reset()
      },
    }
  }
</script>
<style lang="scss">
  .mt-80 {
    margin-top: 80px;
  }
  .watch-more {
    cursor: pointer;
  }
  .stories {
    font-family: 'Raleway', sans-serif;
    display: flex;
    justify-content: flex-start;
    margin-top: 16px;
    flex-wrap: wrap;
    &-item:nth-child(3n + 3) {
      margin-right: 0;
    }
    &-item {
      position: relative;
      width: 33%;
      border: 1px solid #dee2ed;
      padding: 10px;
      margin-bottom: 8px;
      border-radius: 9px;
      margin-right: 8px;
      min-height: 232px;
      .cross {
        position: absolute;
        top: -20px;
        right: -5px;
      }
      &-img {
        width: 100%;
        max-width: 320px;
        display: block;
        margin: 0 auto 12px;

      }
      &-title {
        font-size: 24px;
        line-height: 1;
      }
      &-discription {
        font-size: 18px;
      }
      &-text {
        font-family: 'Raleway', sans-serif;
        white-space: pre-line;
        font-size: 14px;
        margin-bottom: 0;
      }
    }
  }
  .ml-220 {
    margin-left: 240px;
    padding-right: 15px;
  }
  .form-elems {
    input, textarea {
      border-radius: 4px !important;
      border: solid 1px #dee2ed !important;
      background-color: #ffffff !important;
    }
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }
  input.title-input {
    width: 100% !important;
    height: 32px !important;
    font-size: 16px !important;
    padding: 5px !important;
    margin-top: 8px !important;
  }
  input.discription-input {
    width: 49%  !important;
    padding: 5px  !important;
    height: 32px  !important;
    font-size: 16px  !important;
    margin-top: 8px  !important;
  }
  textarea.text-input {
    width: 100%  !important;
    height: 256px  !important;
    border-radius: 4px  !important;
    border: solid 1px #dee2ed  !important;
    background-color: #ffffff !important;
    font-size: 14px !important;
    padding: 8px !important;
    margin-top: 8px  !important;
  }
  .type-submit {
    border: none;
    margin-top: 8px;
    width: 200px;
    height: 32px;
    border-radius: 4px;
    background-color: #4c71f3;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.33;
    color: #ffffff;
  }
  .loader {
    display: flex;
    justify-content: center;
  }
  .pt-100 {
    padding-top: 100px;
  }
</style>